export const pluginPermissions = {
  displayPlugin: [{
    action: 'plugin::courses.read',
    subject: null
  }],
  editMetadata_courseView: [{
    action: 'plugin::courses.course-view.edit-metadata',
    subject: null
  }],
  createTestBank_courseView: [{
    action: 'plugin::courses.course-view.create-test-bank',
    subject: null
  }],
  editMetadata_containerView: [{
    action: 'plugin::courses.container-view.edit-metadata',
    subject: null
  }],
  rollbackVersion_containerView: [{
    action: 'plugin::courses.container-view.rollback-version',
    subject: null
  }],
  delete_containerDraftView: [{
    action: 'plugin::courses.container-draft-view.delete',
    subject: null
  }],
  delete_courseDraftView: [{
    action: 'plugin::courses.course-draft-view.delete',
    subject: null
  }],
  readItems_assessmentLearnosityView: [{
    action: 'plugin::courses.assessment-learnosity-view.read-items',
    subject: null
  }],
  editItems_assessmentLearnosityView: [{
    action: 'plugin::courses.assessment-learnosity-view.edit-items',
    subject: null
  }],
  assignItems_assessmentLearnosityView: [{
    action: 'plugin::courses.assessment-learnosity-view.assign-items',
    subject: null
  }],
  createItems_assessmentLearnosityView: [{
    action: 'plugin::courses.assessment-learnosity-view.create-items',
    subject: null
  }],
  deleteTag_assessmentLearnosityView: [{
    action: 'plugin::courses.assessment-learnosity-view.delete-tag',
    subject: null
  }],
  assignExistingTag_assessmentLearnosityView: [{
    action: 'plugin::courses.assessment-learnosity-view.assign-existing-tag',
    subject: null
  }],
  createNewTag_assessmentLearnosityView: [{
    action: 'plugin::courses.assessment-learnosity-view.create-new-tag',
    subject: null
  }],
  editMetadata_assessmentView: [{
    action: 'plugin::courses.assessment-view.edit-metadata',
    subject: null
  }],
  configureTotalTime_assessmentView: [{
    action: 'plugin::courses.assessment-view.configure-total-time',
    subject: null
  }]
};